import { createReducer, on } from '@ngrx/store';
import * as UserActions from './user.actions';
import { initialUserState } from './user.state';

export const userReducer = createReducer(
  initialUserState,

  on(UserActions.login, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(UserActions.loginSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    user: response.user,
    isAuthenticated: true,
    error: null,
  })),

  on(UserActions.loginFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    isAuthenticated: false,
    user: null,
  })),

  on(UserActions.logout, (state) => ({
    ...state,
    loading: true,
  })),

  on(UserActions.logoutSuccess, () => initialUserState),

  on(UserActions.forceLogout, () => initialUserState),

  on(UserActions.initializeAuth, (state) => ({
    ...state,
    loading: true,
  })),

  on(UserActions.initializeAuthFailure, (state) => ({
    ...state,
    loading: false,
    isAuthenticated: false,
    user: null,
  })),

  on(UserActions.validateToken, (state) => ({
    ...state,
    loading: true,
  })),

  on(UserActions.validateTokenSuccess, (state, { user }) => ({
    ...state,
    user,
    isAuthenticated: true,
    loading: false,
    error: null,
  })),

  on(UserActions.validateTokenFailure, () => initialUserState),

  on(UserActions.updateProfile, (state) => ({
    ...state,
    updateProfileLoading: true,
    updateProfileError: null,
  })),

  on(UserActions.updateProfileSuccess, (state, { user }) => ({
    ...state,
    user,
    isAuthenticated: true,
    updateProfileLoading: false,
    updateProfileError: null,
  })),

  on(UserActions.updateProfileFailure, (state, { error }) => ({
    ...state,
    updateProfileLoading: false,
    updateProfileError: error,
  })),

  on(UserActions.uploadProfilePhoto, (state) => ({
    ...state,
    photoUploading: true,
    updateProfileError: null,
  })),

  on(UserActions.uploadProfilePhotoSuccess, (state, { user }) => ({
    ...state,
    user,
    isAuthenticated: true,
    photoUploading: false,
    updateProfileError: null,
  })),

  on(UserActions.uploadProfilePhotoFailure, (state, { error }) => ({
    ...state,
    photoUploading: false,
    updateProfileError: error,
  })),

  on(UserActions.deleteProfilePhoto, (state) => ({
    ...state,
    photoDeleting: true,
    updateProfileError: null,
  })),

  on(UserActions.deleteProfilePhotoSuccess, (state, { user }) => ({
    ...state,
    user,
    isAuthenticated: true,
    photoDeleting: false,
    updateProfileError: null,
  })),

  on(UserActions.deleteProfilePhotoFailure, (state, { error }) => ({
    ...state,
    photoDeleting: false,
    updateProfileError: error,
  })),
);
